import { Cost, OldCost } from '@r1-frontend/ui-react/components/costs';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export type TSubscriptionCost = {
    oldCost: number | string,
    currentCost: number | string,
}
const SubscriptionCost = ({ oldCost, currentCost, ...props }: TSubscriptionCost): JSX.Element => {
    return (
        <ListContainer $mobile={4} $desktop={8} {...props}>
            <Paragraph4 $smaller as={'span'} $color={COLORS.TextDisabled}>
                <OldCost isMonthly>{oldCost}</OldCost>
            </Paragraph4>
            <Paragraph4 $smaller as={'span'} $color={COLORS.TextInfo}>
                +&nbsp;<Cost>{currentCost}</Cost> к чеку
            </Paragraph4>
        </ListContainer>
    );
};

export default SubscriptionCost;
